import { DataService } from './dataService'
export const pickupTrackingService = {
	getPickupTrackingList: async (data) => {
		return DataService.get('/admin/get_pickup_tracking', data)
	},

	getPickupTrackingDetail: async (data) => {
		return DataService.get('/admin/get_pickup_tracking', data)
	},

	updatePickUpTracking: async (data) => {
		return DataService.post('/admin/update-tracking-job', data)
	},
}

export default pickupTrackingService